module.exports = __webpack_public_path__ + "static/media/fly0099.a1f6d9b6.webp";